import { render, staticRenderFns } from "./purchaseReturnNoticesHistory.vue?vue&type=template&id=249f8022&scoped=true"
import script from "./purchaseReturnNoticesHistory.vue?vue&type=script&lang=js"
export * from "./purchaseReturnNoticesHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnNoticesHistory.vue?vue&type=style&index=0&id=249f8022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f8022",
  null
  
)

export default component.exports